import React from 'react';

import { useAuthContext } from '../../../../containers/login/view-model/contexts/auth-context/AuthContextV1';
import { oms_url } from '../../../config/AppConfig';
import {
  MIN_WIDTH_DESKTOP,
  useMediaQuery,
} from '../../../core/hooks/useMediaQuery';
import { HeaderContentEntity } from '../../domain/entities/HeaderContentEntity';
import {
  countOfLiveOrder,
  isCourierOrder,
  orderCrn,
} from '../helpers/OrderHistoryLoadable';
import {
  allocationLinkRedirect,
  courierTrackingLinkRedirect,
} from '../helpers/TrackOrderRedirect';
import { order_history_path } from '../vm/HeaderStore';
import { getVm } from '../vm/HeaderVm';

import LogoComponent from './LogoComponent';
import PrimaryLinksComponent from './PrimaryLinksComponent';
import SecondaryLinksComponent from './SecondaryLinksComponent';

interface HeaderLinksCmpProps {
  data: HeaderContentEntity;
}

function HeaderLinksCmp({
  data,
}: Readonly<HeaderLinksCmpProps>): React.ReactElement {
  const { logo, links } = getVm(data);
  const { driver_partner_link, support_link, for_enterprise_link } = links;
  const isDesktop = useMediaQuery(MIN_WIDTH_DESKTOP);
  const { set_user, is_authenticated, set_is_authenticated, order_history } =
    useAuthContext();

  const onTrackHandler = (): void => {
    const moreThanOneLiveOrder = countOfLiveOrder(order_history) > 1;
    const courierOrder = isCourierOrder(order_history, 0);

    if (moreThanOneLiveOrder) {
      globalThis.location.href = oms_url + order_history_path;
    } else if (courierOrder) {
      courierTrackingLinkRedirect(orderCrn(order_history, 0));
    } else {
      allocationLinkRedirect(orderCrn(order_history, 0));
    }
  };

  return (
    <>
      <LogoComponent logo={logo} isDesktop={isDesktop} />
      <PrimaryLinksComponent
        for_enterprise_link={for_enterprise_link}
        driver_partner_link={driver_partner_link}
      />
      <SecondaryLinksComponent
        is_authenticated={is_authenticated}
        order_history={order_history}
        onTrackHandler={onTrackHandler}
        set_user={set_user}
        set_is_authenticated={set_is_authenticated}
        set_is_mobile_menu_open={(): void => undefined}
        support_link={support_link}
        language_selector={data.language_selector}
      />
    </>
  );
}

export default HeaderLinksCmp;
